
import img0 from './Images/Registration.png';
import img1 from './Images/Organization_Clients.png';
import img2 from './Images/SecureFile_Clients.png';
import img3 from './Images/Add_Registration_Code.png';
import img4 from './Images/Finish_Registration.png';
  
const content = `# Register SecureFile

After the SecureFile software is installed, it needs to be registered with the OnData Platform for one-time only before it can be used. After the 
installation process is completed, or after system reboot if a reboot is required and login as an administrative user, launch the OnData SecureFile 
application for the first time. The OnData SecureFile registration screen will be displayed, as illustrated below. **Note:**  a user with system admin 
access to the computer is required to login and complete the registration process.    

![SecureFile Registration](${ img0 })  

Below are the steps to complete the registration process. Please note a user with System Administrator or Security Administrator role to the OnData 
Platform is required to generate the registration code. If you are not a System Administrator or Security Administrator to the OnData Platform, 
please contact your system administrator and ask for a registration code.  

a. Login to the OnData Portal and navigate to the \`Clients\` tab under \`Organization Settings\`. 
  
![Organization Clients](${ img1 })  

b. Select on the \`SecureFile App\` tab.  

![Organization SecureFile Clients](${ img2 })  

c. Click on the \`Registration Code...\` button and click on the \`Add Registration Code\` button. Select the valid period of the registration code 
and how many times it can be used, and click on the \`Create\` button.

![Add Registration Code](${ img3 })  

d. Provide the newly created registration code to the user who needs to get his/her computer registered. The user can enter the registration code to 
finish the registration process.  

![Finish Registration](${ img4 })  

e. Once the SecureFile application is registered, a user with access to the SecureFile product can login and use the SecureFile software to 
protect sensitive documents and files.  
  
  `
  
export default content;
